/* eslint-disable no-underscore-dangle */
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, InputField, Select } from '@salt/components';
import { sendBroadcast } from '../../api/broadcast';

const CreateBroadcastModal = ({
  handleBroadcastModalClose,
  projectBroadcast,
  setProjectBroadcast,
}) => {
  const { t } = useTranslation();

  const [sending, setSending] = useState(false);

  const handleChange = useCallback(
    (name, value) => {
      setProjectBroadcast({ ...projectBroadcast, [name]: value });
    },
    [projectBroadcast]
  );

  const handleSend = useCallback(() => {
    if (sending) return;

    const fetchData = async () => {
      try {
        await sendBroadcast({
          id: projectBroadcast.id,
          severity: projectBroadcast.severity,
          title: projectBroadcast.title,
          description: projectBroadcast.description,
        });
      } catch (error) {
        console.error(error.message);
      }
      handleBroadcastModalClose();
      setSending(false);
    };

    setSending(true);

    fetchData();
  }, [projectBroadcast, sending]);

  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleBroadcastModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <div className="modal-title">
          <h2 className="w-full mb-2 font-[18px] line-clamp-2 text-ellipsis">
            {t('broadcast.title', { name: projectBroadcast.name })}
          </h2>
          <p className="w-full-block mb-6 text-base">{t('broadcast.description')}</p>
          <p className="w-full-block mb-6 text-base">{t('broadcast.description_required')}</p>

          <div className="my-4">
            <Select
              onClick={(newVal) => handleChange('severity', newVal)}
              width="w-full"
              required
              placeholder="Assign a Broadcast Severity Level"
              labelBackgroundClass="group-focus:bg-secondary-light group-[:not(:placeholder-shown)]:bg-secondary-light"
              backgroundClass="bg-secondary-light"
              renderItems={[
                {
                  id: 'ANNOUNCEMENT',
                  render: () => {},
                  value: 'Announcement',
                },
                {
                  id: 'WARNING',
                  render: () => {},
                  value: 'Warning',
                },
                {
                  id: 'ALERT',
                  render: () => {},
                  value: 'Alert',
                },
              ]}
              value={projectBroadcast.severity}
            />

            <div className="my-4">
              <InputField
                required
                value={projectBroadcast.title}
                onChange={(event) => handleChange('title', event.target.value)}
                placeholder="Broadcast Title"
                backgroundClass="bg-secondary-light"
                labelBackgroundClass="peer-focus:bg-secondary-light peer-[:not(:placeholder-shown)]:bg-secondary-light"
              />
            </div>

            <div className="my-4">
              <InputField
                required
                rows={5}
                value={projectBroadcast.description}
                onChange={(event) => handleChange('description', event.target.value)}
                placeholder="Add Additional Information"
                backgroundClass="bg-secondary-light"
                labelBackgroundClass="peer-focus:bg-secondary-light peer-[:not(:placeholder-shown)]:bg-secondary-light"
              />
            </div>

            <br />
            <Button
              onClick={handleBroadcastModalClose}
              type="neutral"
              className="max-w-[146px] h-[36px] ml-auto"
              paddingClassName="px-6"
            >
              {t('broadcast.cancel')}
            </Button>
            <Button
              onClick={handleSend}
              className="max-w-[146px] h-[36px] ml-auto float-right"
              type="positive"
              paddingClassName="px-6"
              disabled={
                !projectBroadcast.title ||
                projectBroadcast.title?.trim()?.length === 0 ||
                !projectBroadcast.severity ||
                projectBroadcast.severity?.trim()?.length === 0 ||
                !projectBroadcast.description ||
                projectBroadcast.description?.trim()?.length === 0 ||
                !projectBroadcast.id ||
                sending
              }
            >
              {t('broadcast.send')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateBroadcastModal;
